import { render, staticRenderFns } from "./ShopDefaultHeroSection.vue?vue&type=template&id=06ba0386&scoped=true&"
import script from "./ShopDefaultHeroSection.vue?vue&type=script&lang=js&"
export * from "./ShopDefaultHeroSection.vue?vue&type=script&lang=js&"
import style0 from "./ShopDefaultHeroSection.vue?vue&type=style&index=0&id=06ba0386&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ba0386",
  null
  
)

export default component.exports